import SocialBox, { SocialBoxProps } from './SocialBox'

export default SocialBox

export { SocialBoxProps, SocialBox }
